<template>
  <tr class="entry" :class="{checked:checked&&!hide_check_background}">
    <td class="ten wide filename column" @click="emit_select" @dblclick="$emit('enter', entry)">
      <template v-if="!renaming">
        <div>
          <a v-if="!hide_checkbox" class="checker" @click.stop="$emit('toggle_check')">
            <i v-if="checked" class="check square outline icon blue" style="opacity: 0.8"></i>
            <i v-else class="square outline hover icon"></i>
          </a>
          <i class="icon ui blue text" :class="file_icon(entry)" style="opacity: 0.6"></i>
          <a :title="entry.name" @click.stop="$emit('click', entry)">
            <span :class="entry_text_class(entry)">
              {{ entry.name }}
            </span>
          </a>
          <div v-if="!entry.is_synced" class="ui orange active inline mini loader"></div>
          <span v-if="!readonly || fav_mode" class="favicons">
            <a v-if="entry.is_fav" @click.stop="del_fav(entry)" data-tooltip="取消收藏">
              <i class="star icon ui yellow text"></i>
            </a>
            <a v-else @click.stop="add_fav(entry)" data-tooltip="添加收藏">
              <i :class="{hover:!fav_mode}" class="star outline icon ui yellow text"></i>
            </a>
          </span>
        </div>
        <a v-if="show_path" class="ml-8 text-blue-600 cursor-pointer" data-tooltip="转到目录" @click.stop="$emit('goto')">
          位置： {{ space.dirname(entry.path) }}
        </a>
      </template>
      <div v-show="renaming" class="ui fluid input">
        <input :name="'rename-'+ _uid" :id="'rename-' + entry.obj_id" ref="newName" v-model="new_name" type="text" @blur="renaming=false" @keyup.enter="rename" />
      </div>
    </td>
    <td class="one wide ops hidden md:table-cell">
      <div v-if="!readonly" class="ui simple dropdown">
        <i class="right ellipsis horizontal hover icon"></i>
        <div class="menu">
          <div class="item" @click="$emit('download', entry)"><i class="download icon"></i>
            <span>
              下载
            </span>
          </div>
          <div class="item" @click="rename_start"><i class="pencil alternate icon"></i>
            <span>
              重命名
            </span>
          </div>
          <div class="item" @click="show_modal('move-' + _uid)">
            <i class="arrows alternate icon"></i>
            <span>
              移动到
            </span>
            <DirSelectModal :id="'move-' + _uid" @ok="move" :root='space.root' />
          </div>
          <div class="item" @click="show_modal('copy-' + _uid)" >
            <i class="copy alternate icon"></i>
            <span>
              复制到
            </span>
            <DirSelectModal :id="'copy-' + _uid" @ok="copy" :root='space.root' />
          </div>
          <div class="divider"></div>
          <div class="item" @click="show_modal('confirm-delete-' + _uid)">
            <i class="trash alternate icon ui text red"></i>
            <span>
              删除
            </span>
            <Modal :id="'confirm-delete-' + _uid" size="mini" title="删除" :message="delete_modal_message"
                   @ok="$emit('del', entry)" />
          </div>
        </div>
      </div>
    </td>
    <td class="two wide size hidden lg:table-cell">{{ bytes_to_human(entry.size) }}</td>
    <td class="three wide time hidden lg:table-cell"><span :title="'修改时间：' + readable_time(entry.mtime)">{{ format_time_ms(entry.ctime) }}</span></td>
    <Modal :id="'confirm-ext' + _uid" @ok="do_rename">
      <p>
      确定要把文件
      <span class="mx-1 text-teal-500 font-bold">
        {{ entry.name }}
      </span>
      重命名为
      <span class="mx-1 text-teal-500 font-bold">
        {{ new_name }}
      </span>
      吗？改变扩展名可能使文件无法被应用程序正常打开。</p>
    </Modal>
  </tr>
</template>

<script>
import Modal from './modal.vue'
import DirSelectModal from './dir-select-modal.vue'

import printf from 'printf'

function readable_time(t) {
  return printf(
    "%04d-%02d-%02d %d:%02d",
    t.getFullYear(),
    t.getMonth() + 1,
    t.getDate(),
    t.getHours(),
    t.getMinutes());
}

export default {
  name: 'EntryRow',
  props: ['entry', 'checked', 'space', 'readonly', 'hide_checkbox', 'title', 'show_path', 'fav_mode',
          'hide_check_background'],
  components: {
    DirSelectModal,
    Modal,
  },
  data: function () {
    return {
      renaming: false,
      new_name: this.entry.name,
    };
  },
  computed: {
    delete_modal_message() {
      if (this.entry.type == "file") {
        return "确定要删除文件'" + this.entry.name + "'吗？";
      } else {
        return "确定要删除文件夹'" + this.entry.name + "'和所包含的文件吗？";
      }
    },
  },
  asyncComputed: {
  },
  methods: {
    add_fav(entry) {
      console.log("add fav", entry);
      entry.is_fav = true;
      this.$store.dispatch('add_fav', entry);
      this.$forceUpdate();
    },
    del_fav(entry) {
      console.log("del fav", entry);
      entry.is_fav = false;
      this.$store.dispatch('del_fav', entry);
      this.$forceUpdate();
    },
    emit_select() {
      this.$emit("select", this);
    },
    move(dst) {
      this.space.move(this.entry.path, dst).catch(e => {
        this.show_error(this.error_text(e));
      });
    },
    copy(dst) {
      this.space.copy(this.entry.path, dst).catch(e => {
        console.log("copy error:", e);
        this.show_error(this.error_text(e));
      });
    },
    rename_start() {
      this.renaming = true;
      var newName = this.$refs.newName;
      // FIXME: b-dropbox-item-button always focus trigger upon menu hide, and
      // we get click event before it does so. Use a little bit of delay.
      // The real solution is let the component to expose something to change
      //the behavior
      setTimeout(() => {
        newName.focus();
        newName.select();
        var sellen = newName.value.lastIndexOf('.');
        if (sellen == -1) {
          sellen = newName.value.length;
        }
        newName.setSelectionRange(0, sellen);
      } , 50);
    },
    do_rename() {
      this.space.rename(this.entry.path, this.new_name).then(() => {
        this.renaming = false;
      }).catch(e => {
        this.show_error(this.error_text(e));
      });
    },
    rename() {
      if (!this.new_name) {
        return;
      }
      try {
        this.space.validate_name(this.new_name);
      } catch {
        this.show_error("文件名无效");
        return;
      }
      if (this.ext_changed(this.new_name, this.entry.path)) {
        this.show_modal('confirm-ext' + this._uid);
      } else {
        this.do_rename();
      }
    },
    ext_changed(a, b) {
      var ai = a.lastIndexOf('.');
      var bi = b.lastIndexOf('.');
      if (ai < 0 && bi < 0) return false;
      return a.slice(ai) != b.slice(bi);
    },
    check() {
      this.$emit("checked", this.entry);
    },
    uncheck() {
      this.$emit("unchecked", this.entry);
    },
    entry_text_class(e) {
      if (e.type == "dir") {
        return ['ui', 'text', 'blue', 'font-extrabold'];
      }
      return [];
    },
    readable_time(t) {
      return readable_time(t);
    },
    scroll_into_view() {
      this.$el.scrollIntoView();
    },
  },
  mounted() {
    if (this.checked) {
      this.scroll_into_view();
    }
  },
}
</script>

<style scoped>
.check, .icon {
  width: 20px;
  color: #1985A1;
}

.entry-actions {
  opacity: 0;
}

tr:hover .entry-actions {
  opacity: 0.5;
}
.time, .size {
  overflow: hidden;
  width: 100px;
}
.fileicon {
  color: #999;
}
.ops .dropdown {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.ops .ui.dropdown .menu .item {
  padding-right: 40px !important;
}

tr.checked {
  background-color: #FDF4E4 !important;
}

a.checker {
  padding: 3px;
}
.sm a.checker {
  font-size: large;
}

td.filename:hover {
  white-space: normal;
  word-break: break-all;
  overflow-wrap: normal;
  overflow: visible;
}

td.filename {
  white-space: nowrap;
  max-width: 500px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.lg tr .hover.icon {
  opacity: 0;
}
tr:hover .hover.icon {
  opacity: 1;
}
</style>
